import { Observable } from "rxjs";
import { MatDialogRef, MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Injectable } from "@angular/core";
import { WhatsappComponent } from "./whatsapp.component";

interface ConfirmData {
  title?: any;
  message?: any;
  login?: boolean;
}

@Injectable()
export class WhatsappService {
  constructor(private dialog: MatDialog) {}

  confirm(): Observable<boolean> {
    let dialogRef: MatDialogRef<WhatsappComponent>;
    dialogRef = this.dialog.open(WhatsappComponent, {
      width: "380px",
      disableClose: true,
      data: { a: 1 }
    });
    return dialogRef.afterClosed();
  }
}
